module.exports = __webpack_public_path__ + "img/kanta-tag.e50a446f.png";